/* eslint-disable default-case */
import React, { useEffect } from "react";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { FaPeopleGroup } from "react-icons/fa6";
import { useState } from "react";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import MaterialSelect from "../../components/MasterSelect";
import MaterialButton from "../../components/MaterialButton";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { Country, State, City } from "country-state-city";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  createItem,
  deleteItem,
  fetchById,
  updateItem,
} from "../../ApiBaseUrl";
import { useLoading } from "../../context/loading";
import Swal from "sweetalert2";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";

const AddBranch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state;

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const { setCirleLoading } = useLoading();

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [employeeList, setEmployeeList] = useState([]);
  const [resources, setResources] = useState({
    branchName: [
      { value: "Mr.", label: "Mr." },
      { value: "Ms.", label: "Ms." },
      { value: "Mrs.", label: "Mrs." },
      { value: "Dr.", label: "Dr." },
    ],
    gender: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
    ],
    branchIncharge: [
      { value: "manager1", label: "Manager1" },
      { value: "manager2", label: "Manager2" },
    ],
    employeeType: [
      { value: "type1", label: "Type1" },
      { value: "type2", label: "Type2" },
    ],
    department: [
      { value: "department1", label: "Department1" },
      { value: "department2", label: "Department2" },
    ],
    designation: [
      { value: "designation1", label: "Designation1" },
      { value: "designation2", label: "Designation2" },
    ],
  });

  //   Branch Name*, Description, Address*, State*, Zip Code*, Branch Incharge*.

  const [branchData, setBranchData] = useState({
    branchName: null,
    description: "",
    address: "",
    state: "",
    zipCode: "",
    branchIncharge: null,

    branchNameStatus: "unchecked",
    descriptionStatus: "unchecked",
    addressStatus: "unchecked",
    stateStatus: "unchecked",
    zipCodeStatus: "unchecked",
    branchInchargeStatus: "unchecked",
  });

  const [originalData, setOriginalData] = useState({
    branchName: null,
    description: "",
    address: "",
    state: "",
    zipCode: "",
    branchIncharge: null,
  });

  useEffect(() => {
    if (id) {
      fetchBranchById(id);
      setTogglePage({
        view: true,
        edit: false,
      });
    }
  }, [id]);

  const fetchBranchById = async (id) => {
    setCirleLoading(true);
    try {
      const datas = await fetchById("Branch", id, [
        "id",
        "name",
        "description",
        "address",
        "state",
        "zipCode",
        "branchIncharge",
      ]);
      const data = datas.getBranchById;

      // Update the branch data with proper handling for togglePage.view
      setBranchData({
        branchName: data.name,
        description: data.description,
        address: data.address,
        state: { label: data.state, value: data.state },
        zipCode: data.zipCode,
        branchIncharge: {
          label: data.branchIncharge,
          value: data.branchIncharge,
        },

        branchNameStatus: "success",

        addressStatus: "success",
        stateStatus: "success",
        zipCodeStatus: "success",
      });

      setOriginalData({
        branchName: data.name,
        description: data.description,
        address: data.address,
        state: { label: data.state, value: data.state },
        zipCode: data.zipCode,
        branchIncharge: {
          label: data.branchIncharge,
          value: data.branchIncharge,
        },
      });
    } catch (error) {
      console.error("Error fetching data by ID:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleBranchDataChange = (event, selectEvent) => {
    let employeeState = { ...branchData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "branchIncharge") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "state") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      employeeState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "description":
          {
            const alphaNLengthRegex = new RegExp("^.{1,150}$", "s");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "address":
          {
            const alphaNLengthRegex = new RegExp("^.{1,150}$", "s");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "state":
          {
            const alphaNumberLengthRegex = new RegExp("^([A-Za-z0-9 ]{1,20})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "branchName":
          {
            const alphaNumberLengthRegex = new RegExp("^([A-Za-z0-9 ]{1,20})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "zipCode":
          {
            const phoneRegex = new RegExp("^[0-9]{6}$");

            if (phoneRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        employeeState[event.target.name] = event.target.value;
      }
    }
    setBranchData(employeeState);
  };
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      branchData.addressStatus === "success" &&
      branchData.stateStatus === "success" &&
      branchData.branchNameStatus === "success" &&
      branchData.zipCodeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddBranch = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        submitBranch();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleBackBranch = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Cancel your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        discardData();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const discardData = () => {
    setBranchData({
      branchName: originalData.branchName,
      description: originalData.description,
      address: originalData.address,
      state: originalData.state,
      zipCode: originalData.zipCode,
      branchIncharge: originalData.branchIncharge,
    });
  };

  const submitBranch = async () => {
    setCirleLoading(true);
    const input = {
      name: branchData.branchName,
      description: branchData.description,
      address: branchData.address,
      state: branchData.state.label,
      zipCode: branchData.zipCode,
      branchIncharge: branchData.branchIncharge
        ? branchData.branchIncharge.value
        : "",
    };

    try {
      if (togglePage.edit === true) {
        updateItem("Branch", id, input, [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ]);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Updated successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/branch");
      } else {
        const data = await createItem("Branch", input, [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ]);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Submitted successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/branch");
      }
    } catch (error) {
      console.error("Error creating branch:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ondeleteemployee();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ondeleteemployee = async () => {
    try {
      deleteBranchData(id);
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const deleteBranchData = async (id) => {
    setCirleLoading(true);
    try {
      const response = await deleteItem("Branch", id);
      console.log(response?.deleteBranch, "response");
      if (response?.deleteBranch?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response?.deleteBranch?.message,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/branch");
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: response?.deleteBranch?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      navigate("/branch");
    } finally {
      setCirleLoading(false);
    }
  };
  const onEmployeeeSubmit = async () => {
    const query = `query GetAllUsers {
  allUsersDetail {
    	id
      firstName
      lastName
      fathersName
      dateOfBirth
      email
      gender
      username
      empid
      contactNumber
      secondaryContactNumber
      aadharNumber
      panNumber
      employeeType
      category
      branch
      maritalStatus
      address
      country
      state
      city
      zipCode
      dateOfJoining
      LastWorkingDay
      otApplicable
      shift
      esicNumber
      uanNumber
      memberId
      isUser
      isActive
      role {
        id
      }
      bankDetails {
        accountNumber
        bankName
        ifscNumber
        branchName
        cifNumber
      }
      salaryDetails {
        basicAmount
        daAmount
        mealsAmountPerDay
        otAmountPerHour
        shiftPaisa
        attendanceAmount
        busFare
      }
  }
}`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Ensure response structure is correct
      if (
        response.data &&
        response.data.data &&
        response.data.data.allUsersDetail
      ) {
        const empList = response.data.data.allUsersDetail;

        // Filter out employees where empid is empty/null
        const filteredData = empList.filter(
          (val) => val.isUser && val.firstName && val.firstName.trim() !== ""
        );

        // Update state
        setEmployeeList(filteredData);
      } else {
        throw new Error("Invalid response structure from API");
      }
    } catch (error) {
      console.error("Error fetching employee list:", error);
    }
  };
  useEffect(() => {
    onEmployeeeSubmit();
  }, []);
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" spacing={0}>
                <IconButton
                  onClick={() => {
                    navigate("/branch");
                  }}
                  sx={{ mr: 1, mt: -0.7 }}
                >
                  <ArrowBackIcon />
                </IconButton>{" "}
                <MaterialTypography variant="h5" fontWeight="medium">
                  {togglePage.edit
                    ? "Update branch details"
                    : togglePage.view
                    ? "View branch details"
                    : "Add Branch Details"}
                </MaterialTypography>
              </Stack>
              {id && togglePage.view === true && (
                <ButtonGroup
                  variant="outlined"
                  aria-label="Loading button group"
                >
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={AddDelete}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </MaterialButton>
                </ButtonGroup>
              )}
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1}>
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Branch information
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Branch name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="branchName"
                  placeholder="Enter Branch Name"
                  value={branchData.branchName}
                  onChange={handleBranchDataChange}
                  error={branchData.branchNameStatus === "error" ? true : false}
                  success={
                    branchData.branchNameStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                />
                {branchData.branchNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Branch Name should be maximum 20 characters long and can
                      contain only alphabets and numbers
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    State <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="state"
                  customStyles={{ optionPadding: 20 }}
                  value={branchData.state}
                  onChange={handleBranchDataChange}
                  options={State.getStatesOfCountry("IN").map((value) => {
                    return {
                      value: value.name,
                      label: value.name,
                      isoCode: value.isoCode,
                      countryCode: value.countryCode,
                    };
                  })}
                  error={branchData.stateStatus === "error" ? true : false}
                  success={branchData.stateStatus === "success" ? true : false}
                  isClearable
                  isDisabled={togglePage.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Zip Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="zipCode"
                  placeholder="Enter Zip Code"
                  value={branchData.zipCode}
                  onChange={handleBranchDataChange}
                  error={branchData.zipCodeStatus === "error" ? true : false}
                  success={
                    branchData.zipCodeStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                />
                {branchData.zipCodeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Zip Code should be 6 characters long and can contain only
                      numbers.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Branch Incharge
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="branchIncharge"
                  customStyles={{ optionPadding: 20 }}
                  value={branchData.branchIncharge}
                  onChange={handleBranchDataChange}
                  options={employeeList.map((value) => {
                    return {
                      value: value.firstName,
                      label: value.firstName,
                    };
                  })}
                  error={
                    branchData.branchInchargeStatus === "error" ? true : false
                  }
                  success={
                    branchData.branchInchargeStatus === "success" ? true : false
                  }
                  isClearable
                  isDisabled={togglePage.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Description
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={3}
                  name="description"
                  placeholder="Enter description"
                  value={branchData.description}
                  onChange={handleBranchDataChange}
                  error={
                    branchData.descriptionStatus === "error" ? true : false
                  }
                  success={
                    branchData.descriptionStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                />
                {branchData.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Description should be a maximum of 150 characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Address <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="address"
                  multiline
                  rows={3}
                  placeholder="Enter Address"
                  value={branchData.address}
                  onChange={handleBranchDataChange}
                  error={branchData.addressStatus === "error" ? true : false}
                  success={
                    branchData.addressStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                />
                {branchData.addressStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Address should be a maximum of 150 characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {togglePage.view ? (
            ""
          ) : togglePage.edit ? (
            <>
              {originalData.branchName === branchData.branchName &&
              originalData.description === branchData.description &&
              originalData.address === branchData.address &&
              originalData.state?.label === branchData.state?.label &&
              originalData.zipCode === branchData.zipCode &&
              originalData.branchIncharge?.label ===
                branchData.branchIncharge?.label ? null : (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handleBackBranch}
                >
                  Discard
                </MaterialButton>
              )}
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleAddBranch}
                disabled={!checkAllFields()}
              >
                Update
              </MaterialButton>
            </>
          ) : (
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddBranch}
            >
              Submit
            </MaterialButton>
          )}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default AddBranch;
